import { toast } from "sonner";
import { api } from "./api";

const copyText = async (text) => {
  try { await navigator.clipboard.writeText(text); toast.success("Message and link copied. Paste it into any app."); return "copied"; }
  catch { toast.error("Could not copy. Use the Link or PDF buttons instead."); return "failed"; }
};

export const canNativeShare = () => typeof navigator !== "undefined" && typeof navigator.share === "function";

export const shareDocument = async ({ title, text, url, pdfPath, filename }) => {
  const full = `${text}\n${url}`;
  if (!canNativeShare()) return copyText(full);
  let files = null;
  if (pdfPath && typeof navigator.canShare === "function") {
    try {
      const res = await api.get(pdfPath, { responseType: "blob" });
      const f = new File([res.data], filename, { type: "application/pdf" });
      if (navigator.canShare({ files: [f] })) files = [f];
    } catch { files = null; }
  }
  try {
    await navigator.share(files ? { title, text, url, files } : { title, text, url });
    return files ? "file" : "text";
  } catch (e) {
    if (e?.name === "AbortError") return "cancelled";
    if (files) {
      try { await navigator.share({ title, text, url }); return "text"; }
      catch (e2) { if (e2?.name === "AbortError") return "cancelled"; }
    }
    return copyText(full);
  }
};
